const StatisticsSegmentedControl = ({ options, value, onChange }) => (
  <div className="statistics-segment">
    {options.map((option) => (
      <button
        key={option.value}
        type="button"
        onClick={() => onChange(option.value)}
        className={
          value === option.value
            ? "statistics-segment__option is-active"
            : "statistics-segment__option"
        }
      >
        {option.label}
      </button>
    ))}
  </div>
);

const StatisticsPeriodToggle = ({ activeMode, onModeChange, t }) => (
  <StatisticsSegmentedControl
    value={activeMode}
    onChange={onModeChange}
    options={[
      { value: "month", label: t("Month") },
      { value: "week", label: t("Week") },
    ]}
  />
);

export { StatisticsSegmentedControl };
export default StatisticsPeriodToggle;
